/* eslint-disable */

import { Injectable } from '@angular/core';
import { LoggerService } from '../logger.service';
import { PrefsService } from '../prefs.service';
import { UtilsService } from '../utils.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Injectable({
  providedIn: 'root'
})
export class SchemaService {
  constructor(
    private logger: LoggerService,
    private utils: UtilsService,
    private prefs: PrefsService
  ) {}

  parse(surveyType) {
    const out = [];
    // get directly from prefs to avoid circular deps (tripSurvey -> schema -> load -> matchers -> tripSurvey)
    return Promise.all([this.prefs.getPromise('surveyPages'), this.prefs.getPromise('hiddenFields')]).then((res) => {
      const self = this;
      // allSurveyPages = res[0],
      const surveyPages = res[0][surveyType];
      const hiddenFields = res[1][surveyType];
      const columnNames = [];
      const addCol = function (newColDef) {
        const name = newColDef[0];
        self.logger.log('Adding db col ' + name + ' ' + newColDef[1], MSRemoteLoggerCategory.SURVEY_SCHEMA_SERVICE);
        if (-1 !== columnNames.indexOf(name)) {
          self.logger.log('Not adding ' + name + ' multiple times', MSRemoteLoggerCategory.SURVEY_SCHEMA_SERVICE);
          return;
        }

        if (!newColDef[1]) {
          throw 'Bad col def ' + self.utils.toJson(newColDef);
        }

        columnNames.push(name);
        out.push(newColDef);
      };

      if (surveyPages == null) {
        self.logger.log(`No ${surveyType} pages available for parsing`, MSRemoteLoggerCategory.SURVEY_SCHEMA_SERVICE);
        return out;
      }

      hiddenFields.forEach((f) => {
        const colTypeMap = {
          currency: 'NUMERIC',
          integer: 'INTEGER',
          textbox: 'TEXT',
          geocoder: 'TEXT'
        };
        addCol([f.name, colTypeMap[f.type] || 'TEXT']);
      });

      surveyPages.forEach(function (page) {
        let isRoster = false;
        if (!page.questions) {
          return; // start, end
        }

        page.questions.forEach(function (question) {
          const addSubfieldCol = function (answer) {
            const subfieldTypeMap = {
              currency: 'NUMERIC',
              integer: 'INTEGER'
            };
            addCol([answer.subfield.name, subfieldTypeMap[answer.subfield.type], !!answer.isRoster]);
          };
          const getTextboxType = function (question) {
            const textboxTypeMap = {
              currency: 'NUMERIC',
              integer: 'INTEGER',
              email: 'TEXT',
              text: 'TEXT'
            };
            if (question.hasOwnProperty('params') && question.params.hasOwnProperty('type')) {
              return textboxTypeMap[question.params.type];
            }

            return 'TEXT';
          };
          let i;
          let max;

          if (!question.name) {
            throw 'All survey questions must have a name (' + JSON.stringify(question) + ')';
          }
          if (question.isRoster) {
            isRoster = true;
          }
          switch (question.type) {
            case 'button':
            case 'confirm':
            case 'radio':
              addCol([question.name, 'INTEGER', isRoster]);
              if (question.items) {
                question.items.forEach(function (answer) {
                  if (question.type === 'radio' && answer.subfield) {
                    addSubfieldCol(answer);
                  }
                });
              }
              break;
            case 'integer':
              addCol([question.name, 'INTEGER', isRoster]);
              break;
            case 'buttonBinary':
            case 'checkboxBinary':
            case 'textarea':
            case 'textbox':
            case 'geocoder':
              addCol([question.name, getTextboxType(question), isRoster]);
              break;
            case 'textboxes':
              for (i = 0, max = question.params.maxEntries || 5; i < max; i++) {
                addCol([question.name + '_' + i, getTextboxType(question), isRoster]);
              }
              break;
            case 'geocoders':
              for (i = 0, max = question.params.maxEntries || 5; i < max; i++) {
                addCol([question.name + '_' + i, 'TEXT', isRoster]);
              }
              break;
            case 'selects':
              for (i = 0, max = question.params.maxEntries || 5; i < max; i++) {
                addCol([question.name + '_' + i, 'INTEGER', isRoster]);
              }
              break;
            case 'vehicles':
              for (i = 0, max = question.params.maxEntries || 5; i < max; i++) {
                addCol([question.name + '_year_' + i, 'TEXT', isRoster]);
                addCol([question.name + '_make_' + i, 'TEXT', isRoster]);
                addCol([question.name + '_model_' + i, 'TEXT', isRoster]);
                addCol([question.name + '_other_' + i, 'TEXT', isRoster]);
              }
              break;
            case 'transit':
              addCol([question.name + '_agencyId', 'INTEGER', isRoster]);
              addCol([question.name + '_routeId', 'INTEGER', isRoster]);
              addCol([question.name + '_stopId', 'INTEGER', isRoster]);
              break;
            case 'checkbox':
              if (question.items && question.items.length) {
                question.items.forEach(function (answer) {
                  // HACK_CB: _CB_ is so survey senders (in js and Java) know to transform the data into the format expected by the server
                  //    using this b/c Java back-end only has access to survey data and not survey objects
                  //    putting this on the answer in the rootScope so survey reading/writing doesn't need to duplicate this name
                  answer.dbField = '_CB_' + question.name + '_' + answer.id;
                  addCol([answer.dbField, 'INTEGER', isRoster]);
                  if (answer.subfield) {
                    addSubfieldCol(answer);
                  }
                });
              } else if (question.params && question.params.maxEntries) {
                for (i = 0, max = question.params.maxEntries || 5; i < max; i++) {
                  // HACK_CB
                  addCol(['_CB_' + question.name + '_' + i, 'INTEGER', isRoster]);
                  // no subfields for these
                }
              }
              break;
            case 'null':
              break;
            default:
              throw 'Unhandled question type for "' + page.name + '.' + question.name + '": ' + question.type;
          }
        });
      });

      return out;
    });
  }
}
